import React from 'react';
export function RomaMapWithTrees() {
  return <svg viewBox="0 0 280 200" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full max-w-[280px]" data-id="element-80">
      <defs data-id="element-81">
        <radialGradient id="vignette" cx="50%" cy="50%" r="60%" fx="50%" fy="50%" data-id="element-82">
          <stop offset="40%" stopColor="#0D0D0D" stopOpacity="0" data-id="element-83" />
          <stop offset="100%" stopColor="#0D0D0D" stopOpacity="1" data-id="element-84" />
        </radialGradient>

        {/* Simple stylized tree icon */}
        <g id="tree" data-id="element-85">
          {/* Trunk */}
          <line x1="0" y1="0" x2="0" y2="6" stroke="#C5D82D" strokeWidth="1.5" strokeLinecap="round" data-id="element-86" />
          {/* Leaves */}
          <circle cx="0" cy="-3" r="4.5" fill="#C5D82D" data-id="element-87" />
        </g>
      </defs>

      {/* Background */}
      <rect width="280" height="200" fill="#0D0D0D" data-id="element-88" />

      {/* Map Elements Group */}
      <g opacity="0.8" data-id="element-89">
        {/* GRA (Ring Road) approximation */}
        <path d="M 60 100 C 60 40, 220 40, 220 100 C 220 160, 60 160, 60 100 Z" stroke="#1A1A1A" strokeWidth="1.5" strokeDasharray="4 4" data-id="element-90" />

        {/* Major radiating roads */}
        <path d="M 140 100 L 40 30 M 140 100 L 250 50 M 140 100 L 230 180 M 140 100 L 50 170 M 140 100 L 140 20 M 140 100 L 90 190" stroke="#1A1A1A" strokeWidth="1.5" data-id="element-91" />

        {/* Tiber River (Tevere) */}
        <path d="M 160 -10 C 150 30, 160 60, 130 80 C 100 100, 150 130, 140 150 C 130 170, 90 190, 70 220" stroke="#1E2A3A" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" data-id="element-92" />
      </g>

      {/* Trees scattered across the map */}
      <g data-id="element-93">
        <g transform="translate(120, 70) scale(1)" data-id="element-94">
          <use href="#tree" data-id="element-95" />
        </g>
        <g transform="translate(145, 95) scale(1.2)" data-id="element-96">
          <use href="#tree" data-id="element-97" />
        </g>
        <g transform="translate(100, 110) scale(0.9)" data-id="element-98">
          <use href="#tree" data-id="element-99" />
        </g>
        <g transform="translate(165, 125) scale(1.1)" data-id="element-100">
          <use href="#tree" data-id="element-101" />
        </g>
        <g transform="translate(135, 140) scale(0.8)" data-id="element-102">
          <use href="#tree" data-id="element-103" />
        </g>
        <g transform="translate(180, 75) scale(1)" data-id="element-104">
          <use href="#tree" data-id="element-105" />
        </g>
        <g transform="translate(90, 60) scale(1.1)" data-id="element-106">
          <use href="#tree" data-id="element-107" />
        </g>
        <g transform="translate(110, 150) scale(1)" data-id="element-108">
          <use href="#tree" data-id="element-109" />
        </g>
        <g transform="translate(190, 105) scale(0.9)" data-id="element-110">
          <use href="#tree" data-id="element-111" />
        </g>
        <g transform="translate(155, 55) scale(0.8)" data-id="element-112">
          <use href="#tree" data-id="element-113" />
        </g>
        <g transform="translate(85, 135) scale(1.2)" data-id="element-114">
          <use href="#tree" data-id="element-115" />
        </g>
      </g>

      {/* Vignette Overlay for dissolve to black */}
      <rect width="280" height="200" fill="url(#vignette)" pointerEvents="none" data-id="element-116" />
    </svg>;
}